/**
 * Kiểu điểm vào của giao diện module (ADR-0110). Nhận biết bằng **tên tệp** `frontend.entry`, để không đổi
 * schema manifest, OpenAPI hay `module-registry`:
 *
 * - `*.mount.js`: ESM xuất hàm `mount(el, props)`, viết bằng framework bất kỳ; cổng nạp bằng `import()` gốc.
 * - tệp `.js` khác (thường `remoteEntry.js`): Module Federation, expose `./App` là component React (ADR-0096).
 */
export type LoaiDiemVao = 'mount' | 'federation';

export const HAU_TO_MOUNT = '.mount.js';

export function loaiDiemVao(entry: string): LoaiDiemVao {
  // Bỏ query và hash: URL tự host có thể kèm `?v=…`
  const tep = entry.split(/[?#]/, 1)[0];
  return tep.endsWith(HAU_TO_MOUNT) ? 'mount' : 'federation';
}
